type Props = {
	playbackRate: number;

	onPlaybackRateChange: (rate: number) => void;
};
const AudioPlayerRate = ({ playbackRate, onPlaybackRateChange }: Props) => {
	return (
		<div className="flex items-center gap-1">
			<select
				value={playbackRate}
				onChange={(e) => onPlaybackRateChange(+e.target.value)}
				className="flex w-16 max-w-max border-0 p-0 text-center shadow-none focus:border-0 focus:ring-0 dark:bg-transparent"
			>
				<option value="" disabled>
					Playback Speed
				</option>

				<option value={0.75}>0.75x</option>
				<option value={1} className="self-center">
					1.0x
				</option>
				<option value={1.25}>1.25x</option>
				<option value={1.5}>1.5x</option>
				<option value={1.75}>1.75x</option>
				<option value={2}>2.0x</option>
			</select>
		</div>
	);
};

export default AudioPlayerRate;
